import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "vuecmf_dlg_ref" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_full_screen = _resolveComponent("full-screen")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_copy_document = _resolveComponent("copy-document")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "destroy-on-close": "",
      center: _ctx.center,
      modal: _ctx.show_modal,
      "show-close": _ctx.show_close,
      "close-on-press-escape": _ctx.close_on_press_escape,
      "close-on-click-modal": _ctx.close_on_click_modal,
      class: _normalizeClass(_ctx.custom_class),
      fullscreen: _ctx.fullscreen,
      draggable: true,
      width: _ctx.width,
      top: _ctx.top,
      "append-to-body": _ctx.append_to_body,
      "model-value": _ctx.dialogVisible,
      onClose: _ctx.close,
      onClosed: _ctx.dlgClosed,
      onOpened: _ctx.opened,
      onOpen: _ctx.open
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", {
          innerHTML: _ctx.title,
          class: "vuecmf_dlg_title"
        }, null, 8, _hoisted_2),
        _createVNode(_component_el_button, {
          class: "el-dialog__headerbtn min_btn",
          title: "最小化",
          onClick: _ctx.minScreen
        }, {
          default: _withCtx(() => [
            _createTextVNode("—")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          class: "el-dialog__headerbtn screen_btn",
          onClick: _ctx.toggleScreen
        }, {
          default: _withCtx(() => [
            ( _ctx.fullscreen === false )
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  title: "最大化"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_full_screen)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_icon, {
                  key: 1,
                  title: "还原"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_copy_document)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      footer: _withCtx(() => [
        _renderSlot(_ctx.$slots, "footer")
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, { ref: "scrollbarRef" }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "content")
          ]),
          _: 3
        }, 512)
      ]),
      _: 3
    }, 8, ["center", "modal", "show-close", "close-on-press-escape", "close-on-click-modal", "class", "fullscreen", "width", "top", "append-to-body", "model-value", "onClose", "onClosed", "onOpened", "onOpen"])
  ], 512))
}